module.exports = __webpack_public_path__ + "static/media/bogo.687b4828.png";